import React from "react";

const NoOptions = ({ definitions }) => {
    const definitionNames = definitions.map((d) => <li key={d.key}>{d.name}</li>);

    return (
        <div>
            <b className="txt-error">No bullet options are available.</b>
            <p>Values come from the following attributes:</p>
            <ul>{definitionNames}</ul>
        </div>
    );
};

export default NoOptions;
